// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

//ENUMS
// eslint-disable-next-line no-unused-vars
import { ProjectSort } from "@/enums/Project/ProjectSort.js";

// ## Project Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, sortBy: ProjectSort, sortOrder: 'ASC' | 'DESC', userId: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.MainProject.GetAll(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Project Create
/**
 *
 * @param {{ "projectNo": "string"}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.MainProject.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.MainProject.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project Update
/**
 *
 * @param  {{ "projectNo": "string"}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.MainProject.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.MainProject.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project ReactivateProject
/**
 *
 * @param {{ id: number }} form
 *
 * @returns
 */
export const ReactivateProject = async (form) => {
  const response = await $api.post(
    Endpoints.MainProject.ReactivateProject(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  ReactivateProject,
};
